import React, { useState, useEffect } from "react";
import classes from './Generalledger.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from "react-router-dom";
import svg from "../../Assets/SVG.jpg";
import filter from "../../Assets/SVG (1).png";
import exported from "../../Assets/SVG (4).png";
import date from "../../Assets/SVG (2).png";
import { Eye, Undo2 } from "lucide-react";
import Swal from "sweetalert2";
import Balance from "../Balance/Balance";
import Footer from "../../Components/Footer/Footer";
import JournalModal from "./Journal/Journal";
import api, { withCompanyId } from "../../Components/API/Api";

const Generalledger = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [reverseLoading, setReverseLoading] = useState(false);
    const [reversedRows, setReversedRows] = useState({});
    const [selectMetrics, setSelectedMetrics] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [openJournalModal, setOpenJournalModal] = useState(false);
    const [viewJournalModalOpen, setViewJournalModalOpen] = useState(false);
    const [selectedJournal, setSelectedJournal] = useState(null);
    const [reference, setReference] = useState('');
    const [transactionDate, setTransactionDate] = useState('');
    const [rows, setRows] = useState([]);
    const [initialData, setInitialData] = useState(null); // <-- but then where do you get this from?
    const [journalDetails, setJournalDetails] = useState(null);
    const [loadingDetails, setLoadingDetails] = useState(false);

    const fetchTable = async () => {
        try {
            const res = await api.get('/v1/fetch-distinct-journal-entries');
            if (res.data && res.data.data) {
                setTableData(res.data.data);
            }
        } catch (err) {
            console.error(err);
        }
    };
    const [clickedRows, setClickedRows] = useState({});

    // Reverse modal state
    const [openReverseModal, setOpenReverseModal] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    useEffect(() => {
        if (initialData) {
            setReference(initialData.uuid); // or jv_number if different
            setTransactionDate(initialData.transaction_date);
            setRows([
                {
                    accountId: initialData.account_id,
                    accountDisplay: initialData.account_name,
                    description: initialData.description,
                    debit: initialData.total_debit,
                    credit: initialData.total_credit,
                    showDropdown: false
                }
            ]);
        }
    }, [initialData]);


    // Fetch metrics
    useEffect(() => {
        const fetchMetrics = async () => {
            try {
                const res = await api.get('/v1/metrics/journal-entries-metrics');
                if (res.data && res.data.status && res.data.data) {
                    setSelectedMetrics(res.data.data);
                }
            } catch (err) {
                setSelectedMetrics(null);
            }
        };
        fetchMetrics();
    }, []);

    // Fetch table data
    useEffect(() => {
        fetchTable();
    }, []);

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Journal Entry</h2>
                    <h1 className={classes.Titles}>
                        View all accounting transactions and account balances in chronological order.
                    </h1>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total debits</p>
                                <p className={classes.kdptg1}>{selectMetrics?.total_debits?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Credits</p>
                                <p className={classes.kdptg2}>{selectMetrics?.total_credits?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Trial balance</p>
                                <p className={classes.kdptg3}>{selectMetrics?.trial_balance?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Balanced</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Entries</p>
                                <p className={classes.kdptg4}>{selectMetrics?.total_entries?.toLocaleString() ?? '0'}</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={svg} alt="svg" className={classes.searchIcon} />
                            <input type="text" className={classes.searchBar} placeholder="Search ledger..." />
                        </div>

                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All accounts</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <img src={date} alt="date" className={classes.dateicon} />
                            <input type="text" className={classes.thirdBar} placeholder="Date Range" />
                        </div>

                        <div className={classes.inputWrapper}>
                            <img src={filter} alt="Filter" className={classes.filterIcon} />
                            <input type="text" className={classes.secondBar} placeholder="Filter" />
                        </div>
                    </div>
                    <div className={classes.inputWrapper}>
                        <button className={classes.btnss} onClick={() => setOpenJournalModal(true)}>
                            <img src={exported} alt="added" className={classes.invoiceIcon} />
                            Journal Entry
                        </button>
                    </div>
                </div>

                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>Date</th>
                                <th>JV Reference</th>
                                <th>Description</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.length > 0
                                ? tableData.map((row, index) => (
                                    <tr key={index} className={classes.tableRow}>
                                        <td className={classes.tableCell}>{row.transaction_date}</td>
                                        <td className={classes.tableCell}>{row.uuid}</td>
                                        <td className={classes.tableCell}>{row.description}</td>
                                        <td style={{ color: 'rgba(37, 99, 235, 1)', textAlign: 'right' }}>
                                            {parseFloat(row.total_debit).toLocaleString()}
                                        </td>
                                        <td style={{ color: 'rgba(22, 163, 74, 1)', textAlign: 'right' }}>
                                            {parseFloat(row.total_credit).toLocaleString()}
                                        </td>
                                        <td className={`${classes.tableCell} ${classes.iconActions}`}>
                                            <Eye
                                                size={16}
                                                style={{
                                                    color: 'rgb(22,163,74)',
                                                    marginRight: "8px",
                                                    cursor: clickedRows[index] ? 'not-allowed' : 'pointer',
                                                    opacity: clickedRows[index] ? 0.5 : 1
                                                }}
                                                disabled={loadingDetails || clickedRows[index]}
                                                onClick={async () => {
                                                    try {
                                                        setLoadingDetails(true);
                                                        setClickedRows(prev => ({ ...prev, [index]: true }));

                                                        // Fetch journal details by uuid
                                                        const res = await api.get('/v1/journal/entries-details', { params: { uuid: row.uuid } });

                                                        if (res.data.status) {
                                                            setJournalDetails(res.data.data);
                                                            setViewJournalModalOpen(true);
                                                        } else {
                                                            Swal.fire('Error', res.data.message?.uuid?.[0] || res.data.message || 'Failed to fetch journal details.', 'error');
                                                            setClickedRows(prev => ({ ...prev, [index]: false }));
                                                        }
                                                    } catch (err) {
                                                        console.error(err);
                                                        Swal.fire('Error', 'Something went wrong while fetching details.', 'error');
                                                        setClickedRows(prev => ({ ...prev, [index]: false }));
                                                    } finally {
                                                        setLoadingDetails(false);
                                                    }
                                                }}

                                            />




                                            <Undo2
                                                size={16}
                                                style={{ color: 'rgb(255, 2, 2)', cursor: 'pointer' }}
                                                onClick={() => {
                                                    setSelectedRowIndex(index);
                                                    setOpenReverseModal(true);
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))
                                : Array.from({ length: 7 }).map((_, index) => (
                                    <tr key={index} className={classes.tableRow}>
                                        <td className={`${classes.tableCell} ${classes.skeleton}`}>&nbsp;</td>
                                        <td className={`${classes.tableCell} ${classes.skeleton}`}>&nbsp;</td>
                                        <td className={`${classes.tableCell} ${classes.skeleton}`}>&nbsp;</td>
                                        <td className={`${classes.tableCell} ${classes.skeleton}`}>&nbsp;</td>
                                        <td className={`${classes.tableCell} ${classes.skeleton}`}>&nbsp;</td>
                                        <td className={`${classes.tableCell} ${classes.skeleton}`}>&nbsp;</td>
                                    </tr>
                                ))}
                        </tbody>

                    </table>
                </div>

                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td className={classes.frston}>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.twono}>2</td>
                            <td className={classes.lastno} >Last</td>
                        </tr> 
                    </tfoot>
                </table>

                <div className={classes.lasone}>
                    <div className={classes.paginationDisplay}>Displaying 1 - {tableData.length} of {tableData.length}</div>
                </div>
            </div>

            <JournalModal
                isOpen={openJournalModal}
                onClose={() => setOpenJournalModal(false)}
                onSaveSuccess={fetchTable}
            />
            {viewJournalModalOpen && journalDetails && (
                <Balance
                    isOpen={viewJournalModalOpen}
                    onClose={() => setViewJournalModalOpen(false)}
                    initialData={journalDetails}
                />
            )}
            {openReverseModal && (
                <div className={classes.modalOverlay}>
                    <div className={classes.modalContent}>
                        <h2>Confirm Reversal</h2>
                        <p>Are you sure you want to reverse this balance?</p>
                        <div className={classes.modalActions}>
                            <button className={classes.cancelBtn} onClick={() => setOpenReverseModal(false)}>Cancel</button>
                            <button
                                className={classes.confirmBtn}
                                disabled={reverseLoading || reversedRows[selectedRowIndex]}
                                onClick={async () => {
                                    try {
                                        setReverseLoading(true);

                                        const res = await api.post(
                                            '/v1/journal/reverse-balance-brought-forward',
                                            withCompanyId({ uuid: tableData[selectedRowIndex].uuid })
                                        );

                                        if (res.data.status) {
                                            // Success
                                            const updatedData = tableData.filter((_, i) => i !== selectedRowIndex);
                                            setTableData(updatedData);

                                            // mark this row as reversed
                                            setReversedRows(prev => ({ ...prev, [selectedRowIndex]: true }));

                                            await Swal.fire('Reversed!', res.data.message, 'success');
                                        } else {
                                            await Swal.fire('Cannot Reverse', res.data.message || 'This transaction cannot be reversed.', 'error');

                                            setReversedRows(prev => ({ ...prev, [selectedRowIndex]: true }));
                                        }

                                    } catch (err) {
                                        console.error(err);
                                        await Swal.fire('Error', err?.response?.data?.message || 'Something went wrong. Please try again.', 'error');
                                    } finally {
                                        setReverseLoading(false);
                                        setOpenReverseModal(false);
                                    }
                                }}
                            >
                                {reverseLoading ? 'Processing...' : 'Reverse'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    )
}

export default Generalledger;
